import { get } from '../tools/http';

export default {
    state: {
        roleAttributes: {},
    },
    mutations: {
        SET_ROLE_ATTRIBUTES: (state, v) => state.roleAttributes = v,
    },
    actions: {
        async loadRoleAttributes(ctx){
            if (ctx.rootGetters.getUserRoles.length < 2) {
                return;
            }

            const items = await get('identity', 'api/v1/roles', null, true);

            ctx.commit('SET_ROLE_ATTRIBUTES', items.reduce((acc, v) => {
                acc[v.name] = v.attributes;
                return acc;
            }, {}));
        },
    },
};